export default (handler, key = "Enter") =>
  (event) => {
    if (event.key === key) {
      handler();
    }
  };
